import type { TSignupElement } from '@shared/dream-components/src';
import { ClientOnly } from 'remix-utils/client-only';

interface ClientSideFormProps {
  visitToken?: string;
  referralId?: string;
  boostAffiliateRecommendingPublicationId?: string | null;
  premiumOfferId?: string;
  redirectUrl?: string;
  fallbackPath?: string;
  customFormType?: TSignupElement['attrs']['customFormType'];
}

const ClientSideInputs = ({
  visitToken,
  referralId,
  boostAffiliateRecommendingPublicationId,
  premiumOfferId,
  redirectUrl,
  fallbackPath,
  customFormType,
}: ClientSideFormProps) => {
  return (
    <ClientOnly fallback={null}>
      {() => (
        <>
          <input hidden name="ref" value={referralId || ''} onChange={() => null} />
          <input hidden name="bhba" value={boostAffiliateRecommendingPublicationId || ''} onChange={() => null} />
          <input hidden name="visit_token" value={visitToken || ''} onChange={() => null} />
          <input hidden name="premium_offer_id" value={premiumOfferId || ''} onChange={() => null} />
          {fallbackPath && <input hidden name="fallback_path" defaultValue={fallbackPath} />}
          {redirectUrl && <input hidden name="redirect_path" defaultValue={redirectUrl} />}
          <input hidden name="is_js_enabled" defaultValue="true" />
          {customFormType && <input hidden name="custom_form_type" defaultValue={customFormType} />}
        </>
      )}
    </ClientOnly>
  );
};

export default ClientSideInputs;
